/**
 * jai1 tasks done <id> [-j]
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { TaskService } from '../../services/task.service.js';
import type { TaskDoneOptions } from '../../types/task.types.js';

export function createTaskDoneCommand(): Command {
    return new Command('done')
        .description('Mark task as done')
        .argument('<id>', 'Task ID (e.g. T-001)')
        .option('-j, --json', 'Output JSON')
        .action(async (id: string, options: TaskDoneOptions) => {
            const service = new TaskService();

            try {
                const task = await service.markDone(id);

                if (options.json) {
                    console.log(JSON.stringify(task, null, 2));
                    return;
                }

                console.log(chalk.green(`✅ ${task.id}: ${task.title} → done`));
            } catch (error) {
                console.error(chalk.red(`❌ ${error instanceof Error ? error.message : String(error)}`));
                process.exit(1);
            }
        });
}
